// extracted by mini-css-extract-plugin
export default {"team-card":"styles_team-card__KgcSY","image":"styles_image__8r1V0","info":"styles_info__0YkLE"};